<template>
  <div class="box-detalhe" v-if="config.open">
    <el-row style="padding: 0 0 15px 0">
      <el-col :span="24">
        <Mapa v-if="config.open" :locations="locations" :config="config" :pin-color="esquemaDeCor.aplicacao.corPrimariaAplicacao">
          <el-card class="card-map" shadow="always" v-if="config.showCardInfo">
            <el-row>
              <el-col :span="24">
                 <span class="title-card-map">
                   <b>{{ prestador.nome_prestador }}</b>
                </span>
                <span v-if="prestador.acreditacoes.length > 0">
                  <span style="margin-right: 10px" v-for="(acreditacao, index) in prestador.acreditacoes"
                        :key="index"
                        :name="index">
                    <img v-if="acreditacao" :src="acreditacao.icone" />
                  </span>
                </span>
                <span class="text-card-map">
                  {{ prestador.endereco }}, {{
                    prestador.numero
                  }} {{ prestador.complemento !== '' ? `, ${prestador.complemento}` : '' }}
                      - {{ prestador.bairro }}, {{ prestador.cidade }}, {{ prestador.uf_estado }} <br />
                  {{ prestador.telefone_primario }} {{
                    prestador.telefone_secundario !== ' ' ? `- ${prestador.telefone_secundario}` : ''
                  }}
                </span>
              </el-col>
            </el-row>
            <el-row class="buttons-card-map" v-if="config.showActions">
              <el-col style="max-width: 170px;" :span="12">
                <el-button class="button-gmap" :style="colorButton" type="primary" @click="openGmap">
                  <svg-icone style="vertical-align: bottom;" :height="15" :width="15" cor="#FFFFFF"
                             icone="icon_nav_map"></svg-icone>
                  Abrir no google Maps
                </el-button>
              </el-col>
              <el-col style="max-width: 170px;" :span="12">
                <el-button class="button-copy" :style="colorBorder" type="text" @click="copyText()">
                  <svg-icone style="vertical-align: bottom;" icone="Icon_btn_copy"
                             :cor="estilo.aplicacao.corPrimariaAplicacao"></svg-icone>
                  Copiar endereço
                </el-button>
              </el-col>
            </el-row>
          </el-card>
          <div class="copiado">
            <span v-if="copiado" class="copiado-alerta">Endereço copiado!</span>
          </div>
        </mapa>
      </el-col>
    </el-row>
  </div>
</template>

<script>

import Mapa from '@/components/mapa/Mapa'
import { mapState } from 'vuex'

export default {
  name: 'Func4DetalheMapa',
  components: {
    Mapa
  },
  computed: {
    ...mapState('SetupApp', ['esquemaDeCor'])
  },
  props: {
    config: {
      type: Object,
      required: true
    },
    locations: {
      type: Array,
      required: true
    },
    prestador: {
      type: Object,
      required: true
    }
  }
}

</script>
